import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';

// Types
export type FeedbackType = 'upvote' | 'downvote';

export interface FeedbackRequest {
  messageId: string;
  conversationId: string;
  feedbackType: FeedbackType;
  message?: string;
}

export interface FeedbackResponse {
  message: string;
}

// API function to submit feedback
export const submitFeedback = async (
  data: FeedbackRequest,
): Promise<FeedbackResponse> => {
  const response = await api.post('/api/core/pleri/metrics/feedback', data);
  return response.data;
};

// React Query hook for submitting feedback
export const useSubmitFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation<FeedbackResponse, Error, FeedbackRequest>({
    mutationFn: (data) => submitFeedback(data),
    onSuccess: (_, variables) => {
      // Invalidate feedback queries for the specific conversation
      queryClient.invalidateQueries({
        queryKey: ['feedback', variables.conversationId],
      });
    },
  });
};
